import { Box, Collapse, HoverCard, Stack, ThemeIcon } from "@mantine/core";
import { LinksGroup } from "./NavbarLinksGroup/NavbarLinksGroup";
import { useLanguage } from "../../stores/LanguageStore";
import IconCampaigns from "../../assets/icons/IconCampaigns";
import { IconChevronDown, IconClipboard } from "@tabler/icons-react";
import NavItemMenu from "./NavItemMenu";

const CampaignsButton = ({ navbarClosed, opened, setOpened }) => {
  const lang = useLanguage((s) => s.language);

  const ressources = [
    {
      id: "workflows",
      name: lang.header.navigations.workflows.label,
      icon: IconClipboard,
      path: "/statistics/campaigns/workflows",
    },
    {
      id: "campaigns",
      path: "/statistics/campaigns/running",
      icon: IconCampaigns,
      name: lang.api_keys.uses.stats.group_name,
      // name: lang.header.navigations.models.label,
    },
  ];

  return navbarClosed ? (
    <HoverCard position="right-start" offset={4} width={240}>
      <HoverCard.Target>
        <Box>
          <LinksGroup
            closed={navbarClosed}
            name={lang.navbar.campaigns}
            icon={IconCampaigns}
            navbarClosed={navbarClosed}
            onClick={() => {
              setOpened(!opened);
            }}
            hasLinks={true}
            opened={false}
            path={"/statistics"}
            id={"statistics"}
            noNav={false}
          />
        </Box>
      </HoverCard.Target>

      <HoverCard.Dropdown>
        <Stack py={0} mx={-16} gap={0}>
          {ressources.map((item) => (
            <LinksGroup
              key={item.id}
              id={item.id}
              path={item.path}
              icon={item.icon}
              name={item.name}
              navbarClosed={closed}
            />
          ))}
        </Stack>
      </HoverCard.Dropdown>
    </HoverCard>
  ) : (
    <>
      <LinksGroup
        closed={navbarClosed}
        name={lang.navbar.campaigns}
        onClick={() => {
          setOpened(!opened);
        }}
        icon={IconCampaigns}
        navbarClosed={navbarClosed}
        hasLinks={true}
        opened={opened}
        path={"/statistics"}
        id={"statistics"}
        noNav
      />

      <Collapse in={opened}>
        {ressources.map((link) => (
          <NavItemMenu
            is2
            key={link.path}
            item={link}
            navbarClosed={navbarClosed}
          />
        ))}
      </Collapse>
    </>
  );
};

export default CampaignsButton;
